import React from "react";

const MuteNotifications = ({style = {}, size = "36", className = "", fill = "#73788B", stroke="#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M32.333 27.893H3.563v-2.877h1.439V14.99C5.002 7.816 10.799 2 17.948 2c7.15 0 12.947 5.816 12.947 12.991v10.025h1.438v2.877zm-17.98 1.438h7.192a3.596 3.596 0 01-7.193 0z"
            fill={fill}
      />
      <path stroke="#fff" strokeWidth={2} d="M5.548 1.827l27.521 30.966" />
      <path className="u_fill-stroke" strokeWidth={2} d="M3.747 2.369l27.521 30.967" stroke={stroke}/>
    </svg>
);

export default MuteNotifications;
